import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getBalance: () => ({
    url: `Trade/api/v2/User/Balance`,
    method: 'GET',
  }),
  getPortfolio: () => ({
    url: `Trade/api/v2/User/Portfolio`,
    method: 'GET',
  }),
  getPaymentGateways: () => ({
    url: `Trade/api/v1/Ipg/Gateways`,
    method: 'GET',
  }),
  gotoPaymentGateway: (input) => ({
    url: `Trade/api/v1/Ipg/GatewayRequest`,
    method: 'POST',
    data: input,
  }),
  getPFM: () => ({
    url: 'Trade/api/v1/User/Pfm',
    method: 'GET',
  }),
  getStockDetail: (input) => ({
    url: `Trade/api/v2/Stock/Symbol?symbols=${input.stockCode}`,
    method: 'GET',
  }),
  buyETF: (input) => ({
    url: 'Trade/api/v1/StockOrder/Buy',
    method: 'POST',
    data: input,
  }),
  sellETF: (input) => ({
    url: 'Trade/api/v1/StockOrder/Sell',
    method: 'POST',
    data: input,
  }),
  cancelEtfOrder: (input) => ({
    url: 'Trade/api/v1/StockOrder/Cancel',
    method: 'POST',
    data: input,
  }),
  createPreorder: (input) => ({
    url: 'Trade/api/v1/EtfSubscription',
    method: 'POST',
    data: input,
  }),
  getPreorderDetails: (input) => ({
    url: `Trade/api/v1/EtfSubscription`,
    method: 'GET',
    params: input,
    rejectInterceptor: async (error) => {
      if (error.code === 'DataNotFound') {
        return {
          hasSubmittedPreorder: false,
        } as ISchemas['getPreorderDetails']['output'];
      }
      return Promise.reject(error);
    },
    resolveInterceptor: async (response) => {
      return {
        // TODO: fix resolveInterceptor type
        ...(response.data as any).data,
        hasSubmittedPreorder: true,
      };
    },
  }),
  cancelPreorderRequest: (input) => ({
    url: `Trade/api/v1/EtfSubscription/cancel`,
    method: 'POST',
    params: input,
  }),
  getStockAssetTrend: (input) => ({
    url: `Trade/api/v1/Stock/Trend`,
    method: 'GET',
    params: input,
  }),
  getStockDoneTransactions: (input) => ({
    url: `Trade/api/v1/Stock/Trades`,
    method: 'GET',
    params: input,
  }),
  getEtfTransactions: (input) => ({
    url: 'Trade/api/v1/StockOrder/Get',
    method: 'GET',
    params: input,
  }),
  getEtfHistoryRatio: (input) => ({
    url: 'trade/Anonymous/api/v1/General/SymbolHistoryRatio',
    method: 'GET',
    params: input,
  }),
  getParallelMarketHistory: (input) => ({
    url: 'trade/Anonymous/api/v1/General/ParallelMarketHistoryRatio',
    method: 'GET',
    params: input,
  }),
  getChildPFM: (input) => ({
    url: 'Trade/api/v1/user/PfmChildren',
    method: 'GET',
    params: input,
  }),
};

export default apis;
